import { Component } from '@angular/core';
@Component({
    templateUrl: './questionnaire-print.component.html',
    styleUrls: ['../print.component.scss']
})
export class QuestionnairePrintReportComponent {}